import React, { useContext } from "react";
import { NodeGroup } from "react-move";

import {
  ImageOption,
  OptionEnum,
  OptionModeEnum,
  OptionTypeEnum,
} from "@/components/Option";
import { GlobalContext } from "@/contexts";
import { Option, Vote } from "@/service/Model";

import { ImageGroup } from "./styles";

export type ImageOptionsProps = {
  interactionId: string;
  isClickable: boolean;
  isSecret?: boolean;
  onVote: (vote: any, branch?: string) => void;
  options: Option[];
  resolveOption: (option: Option) => OptionEnum | undefined;
  resolveOptionMode: (option: Option) => OptionModeEnum;
  resolvePercent?: (option: Option) => number | undefined;
  slideId: string;
  type: OptionTypeEnum;
};

export const ImageOptions: React.FC<ImageOptionsProps> = (
  props: ImageOptionsProps
): React.JSX.Element => {
  const globalContext = useContext(GlobalContext);
  const startPixel = -30;
  const animationDelay = 250;
  const reactMoveNodes = props.options.map((option: Option, index: number) => {
    return {
      key: index,
      children: (
        <ImageOption
          answer={props.resolveOption(option)}
          description={option.description}
          icons={globalContext.icons}
          imageUrl={option.content}
          interactionId={props.interactionId}
          isClickable={props.isClickable}
          isSecret={props.isSecret}
          key={index}
          mode={props.resolveOptionMode(option)}
          onClick={(vote: Vote) => props.onVote(vote, option.branch)}
          optionId={option.id}
          percent={
            props.resolvePercent ? props.resolvePercent(option) : undefined
          }
          slideId={props.slideId}
          type={props.type}
        />
      ),
    };
  });

  return (
    <NodeGroup
      data={reactMoveNodes}
      keyAccessor={(d: any) => d.key}
      start={() => ({ opacity: 0, move: startPixel })}
      update={() => ({ opacity: [1], move: [0] })}
    >
      {(nodes: any) => (
        <React.Fragment>
          {nodes.map((node: any, index: number) => (
            <ImageGroup
              key={node.key}
              $delay={animationDelay * (index + 1)}
              style={{
                transform: `translateX(${node.state.move}px)`,
                opacity: node.state.opacity,
              }}
            >
              {node.data.children}
            </ImageGroup>
          ))}
        </React.Fragment>
      )}
    </NodeGroup>
  );
};
